// extracted by mini-css-extract-plugin
module.exports = {"background":"VideoPlayer_background__n21Gj","shimmer":"VideoPlayer_shimmer__PAyLV"};